import styled from "styled-components"

const SmallText = styled.div`
  font-size: 0.7em;
  margin-top: 0.5em;
  opacity: 0.66;
  line-height: 1.5em;
`
export default SmallText
